import React from 'react'

import { ReportEmpty } from '@/components/reports/body'

import FailureBody from './FailureBody'

const FailureResults = ({ data }) => {
  if (!data) {
    return <div className='font-semibold text-center p-4'>Please select a site in configure section.</div>
  }

  if (!data.length) {
    return <ReportEmpty><div className='font-semibold text-center p-4'>No results to show.</div></ReportEmpty>
  }

  return <FailureBody data={data} />
}

export default FailureResults
